import HrPolicies from "./HrPolicies";

const HrPoliciesConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/hrPolicies',
            element: <HrPolicies />,
        },
        {
            path: '/hrPolicies/:id',
            element: <HrPolicies />,
        },
    ]
}

export default HrPoliciesConfig;